import React, { useState, Component } from 'react';
import { Modal, Form, Button, Input, InputNumber, Select, Avatar, Radio, message, Tabs } from 'antd';
import { sagaModal } from 'redux-saga-modal';
import styles from './style.module.less';
import Upload from '../CreateOrderDialog/Upload';
import dayjs from 'dayjs';
import UploadImage from "@/components/UploadImage/Upload";
import * as apis from '@/apis'

const isTenantMode = process.env.APP_MODE === 'tenant';

const { Option } = Select;
@Form.create()
class AppealOrderForm extends Component {
  state = {
    loading: false,
    list: [],
    reasonList: [],
    activeKey: '0',
  };

  componentDidMount() {
    //this.fetchList();
    this.initData()
  }

  handleSubmit = () => {
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err);
      }
      if (values?.adjust_type == 1 && values?.appeal_type == 2) {
        if (values?.appeal_amount > this.props?.order?.worker?.balance) {
          message.error('师傅余额不足')
          return false
        }
      }
      //type: 0 商家申请返款 1申请对师傅扣款 2申请对商家扣款
      if (this.props.type == 0 && isTenantMode && values.appeal_state == 3) {
        values.appeal_state = 1 //重新提交申诉
      }
      const user = this.props.user.toJS();
      //普通客服
      if (this.props.type != 0 && user.manager && !user.isTouer) {
        values.appeal_state = 1 //重新提交申诉
      }
      // values._id = this.props.appeal?._id
      values.order_id = this.props.order_id;
      values.type = this.props.type;
      values.ws_id = this.props.ws_id;
      if (values.sq_reason || values.sq_reason_type) {
        values.sq_reason = values.sq_reason || values.sq_reason_type;
        delete values.sq_reason_type
      }
      if (values.appeal_reason || values.appeal_reason_type) {
        values.appeal_reason = values.appeal_reason || values.appeal_reason_type;
        delete values.appeal_reason_type
      }

      values.isAppealClaim = values.radiotype == 2 ? true : false;
      values.from = isTenantMode ? 2 : 1;
      this.props.submit(values);
    })
  };
  initData = (type = 'stiaojia') => {
    apis.getAllReasons({ type: type }).then(res => {
      this.setState({
        reasonList: res.reason || []
      })
    })
  }
  render() {
    const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue } = this.props.form;
    const { loading } = this.state;
    const appeal = this.props.appeal;
    const adjust_type = this.props.type;
    const user = this.props.user?.toJS();
    let isApplyer = true;
    let isReview = false;
    if (adjust_type == 0) {
      //商家审请退款 时商家时申请人 可以编辑
      // isApplyer = (isTenantMode && (!appeal || appeal?.appeal_state == 1 || appeal?.appeal_state == 3))
      isReview = (!isTenantMode && user?.manager && (appeal?.appeal_state == 2 || appeal?.appeal_state == 3))
        || (isTenantMode && (appeal?.appeal_state == 1 || appeal?.appeal_state == 2))
    } else {
      //普通客服申请调价 超级管理员才能审批
      // isApplyer = (!isTenantMode && user?.manager && !user?.isTouer)
      //超级客服是不是已经审核不通过 不通过需要登陆再次申请完才能审核
      isReview = (!isTenantMode && user?.manager && ((user?.isTouer && (appeal?.appeal_state == 2 || appeal?.appeal_state == 3))
        || (!user?.isTouer && (appeal?.appeal_state == 1 || appeal?.appeal_state == 2))))
    }


    const formItemLayout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      layout: 'horizontal',
      labelAlign: "right",

    };
    // this.props.isAppealClaim 是否点击申诉/索赔按钮
    return (
      <Form {...formItemLayout} className={styles.form}>
        {this.props.isAppealClaim && <Form.Item label="类型">
          {getFieldDecorator('radiotype', {
            initialValue: 1,
            rules: [
              { required: true, message: `请选择类型`, }
            ],
          })(
            <Radio.Group onChange={(e) => {

              if (e.target.value == 1) {
                this.initData('stiaojia')
              } else {
                this.initData('suopei')
              }
            }}>
              <Radio value={1}>申诉</Radio>
              <Radio value={2}>索赔</Radio>
            </Radio.Group>,
          )}
        </Form.Item>}
        <Tabs
          defaultActiveKey={this.state.activeKey}
          size="small"
          onChange={(val) => {

            // resetFields()
            this.setState({
              activeKey: val
            })
            this.initData()
          }}>
          {
            this.state.reasonList.map((item, index) => {
              return <Tabs.TabPane tab={item.name} key={String(index)} ></Tabs.TabPane>
            })
          }
        </Tabs>
        {getFieldValue('radiotype') == 2 ?
          (<>
            {<Form.Item label="师傅信息">
              <div style={{ lineHeight: '20px' }}>师傅名称：{this.props?.order?.worker?.realname}</div>
              <div style={{ lineHeight: '20px' }}>可用余额：{this.props?.order?.worker?.available}元</div>
              <div style={{ lineHeight: '20px' }}>保证金：{this.props?.order?.worker?.baozheng}元</div>
              <div style={{ lineHeight: '20px' }}>冻结金额：{this.props?.order?.worker?.dongjie}元</div>
            </Form.Item>}
            <Form.Item label="索赔原因" required width={120}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              style={{ marginBottom: 0 }}>
              {getFieldDecorator('sq_reason_type', {
                rules: [
                  {
                    required: !['其他原因', '其它原因'].includes(getFieldValue('sq_reason_type')),
                    message: '请选择索赔原因',
                  },
                ],
              })(
                <Select placeholder="请选择索赔原因">
                  {
                    this.state.reasonList[this.state.activeKey]?.list.map(reason => {
                      if (reason.groupName && reason.list) {
                        return (
                          <Select.OptGroup key={reason.groupName} label={reason.groupName}>
                            {
                              reason.list.map(reason => (
                                <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                              ))
                            }
                          </Select.OptGroup>
                        )
                      }

                      return <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                    })
                  }
                </Select>
              )}
            </Form.Item>

            {['其他原因', '其它原因'].includes(getFieldValue('sq_reason_type')) && <Form.Item
              colon={false}
              required={false}
              label={(<span style={{ opacity: 0 }}>索赔原因</span>)}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator('sq_reason', {
                rules: [
                  { required: true, message: `请输入索赔原因`, }
                ],
              })(
                <Input.TextArea rows={4} placeholder={`请输入索赔原因`} />
              )}
            </Form.Item>}

            <Form.Item
              label="索赔金额"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator('sq_amount', {
                rules: [
                  { required: true, message: `请输入索赔金额`, }
                ],
              })(
                <InputNumber min={0} placeholder={`请输入索赔金额`} style={{ width: '100%' }} />
              )}
            </Form.Item>
            <Form.Item
              label="相关照片"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
            >
              {getFieldDecorator('images', {
                rules: [
                  { required: true, message: `请上传相关照片` },
                ],
              })(
                <UploadImage />
              )}
            </Form.Item>
          </>)
          :
          (<>
            <Form.Item label="调价类型" style={{ display: isTenantMode ? 'none' : '' }}>
              {getFieldDecorator('adjust_type', {
                initialValue: 2,
                rules: [
                  { required: true, message: `请选择类型`, }
                ],
              })(
                <Radio.Group onChange={() => {
                  setFieldsValue({ appeal_type: 1 })
                }}>
                  <Radio value={2}>商家费用</Radio>
                  <Radio value={1}>师傅费用</Radio>
                </Radio.Group>,
              )}
            </Form.Item>
            {getFieldValue('adjust_type') == 1 && <Form.Item label="师傅信息" style={{ display: isTenantMode ? 'none' : '' }}>
              <div style={{ lineHeight: '20px' }}>师傅名称：{this.props?.order?.worker?.realname}</div>
              <div style={{ lineHeight: '20px' }}>可用余额：{this.props?.order?.worker?.available}元</div>
              <div style={{ lineHeight: '20px' }}>保证金：{this.props?.order?.worker?.baozheng}元</div>
              <div style={{ lineHeight: '20px' }}>冻结金额：{this.props?.order?.worker?.dongjie}元</div>
            </Form.Item>}
            {!isApplyer && (<>
              <Form.Item label="申请人" required style={{ marginBottom: 0 }}>
                <Avatar shape="circle" src={appeal?.user.avatar} />
                <span style={{ paddingLeft: 5 }}>{appeal?.user.name}</span>
              </Form.Item>
              <Form.Item label="申请时间" required style={{ marginBottom: 0 }}>
                <span>{dayjs(appeal?.appeal_time).format('YYYY-MM-DD  HH:mm:ss')}</span>
              </Form.Item></>
            )
            }

            <Form.Item label="调价理由" required width={120} style={{ marginBottom: 0 }}>
              {getFieldDecorator('appeal_reason_type', {
                rules: [
                  {
                    required: !['其他原因', '其它原因'].includes(getFieldValue('appeal_reason_type')),
                    message: '请输入调价理由',
                  },
                ],
              })(
                <Select placeholder="请选择调价理由">
                  {
                    this.state.reasonList[this.state.activeKey]?.list.map(reason => {
                      if (reason.groupName && reason.list) {
                        return (
                          <Select.OptGroup key={reason.groupName} label={reason.groupName}>
                            {
                              reason.list.map(reason => (
                                <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                              ))
                            }
                          </Select.OptGroup>
                        )
                      }

                      return <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                    })
                  }
                </Select>
              )}
            </Form.Item>

            {['其他原因', '其它原因'].includes(getFieldValue('appeal_reason_type')) &&
              <Form.Item
                colon={false}
                required={false}
                label={(<span style={{ opacity: 0 }}>调价理由</span>)}
                style={{ marginBottom: 0 }}
              >
                {getFieldDecorator('appeal_reason', {
                  // initialValue: appeal?.appeal_reason,
                  rules: [
                    {
                      required: true,
                      message: '请输入调价理由',
                    },
                  ],
                })(<Input.TextArea disabled={!isApplyer} rows={4} />)}
              </Form.Item>
            }

            <Form.Item label="图片描述" style={{ marginBottom: 0 }}>
              {getFieldDecorator('images', {
                // initialValue: appeal?.images,
              })(<Upload disabled={!isApplyer} />)}
            </Form.Item>
            <Form.Item label="调价方式" required style={{ marginBottom: 0 }}>
              {getFieldDecorator('appeal_type', {
                initialValue: appeal?.appeal_type ? appeal?.appeal_type : 1,//默认补价
                rules: [
                  {
                    required: true,
                    message: '请选择调价方式',
                  },
                ],
              })(<Select disabled={!isApplyer}>
                <Option key={1} value={1}>下调</Option>
                <Option key={2} value={2} disabled={getFieldValue('adjust_type') == 1}>上调</Option>
              </Select>)}
            </Form.Item>
            <Form.Item label="金额(元)" required style={{ marginBottom: 0 }}>
              {getFieldDecorator('appeal_amount', {
                initialValue: 0,
                rules: [
                  {
                    required: true,
                    message: '请输入金额',
                  },
                ],
              })(<InputNumber disabled={!isApplyer} max={1000} min={0} precision={2} />)}
            </Form.Item>
            {/* {appeal && (<div>
              <Form.Item label="处理结果" required style={{ marginBottom: 0 }}>
                {getFieldDecorator('appeal_state', {
                  initialValue: appeal ? appeal.appeal_state : 2,
                  rules: [
                    {
                      required: true,
                      message: '请选择处理结果',
                    },
                  ],
                })(<Select style={{ width: '100%' }} disabled={isApplyer || appeal?.appeal_state == 2 || appeal?.appeal_state == 3}>
                  <Option key="同意" value={2}>同意
                  </Option>
                  <Option key="拒绝" value={3}>驳回
                  </Option>
                  <Option key="待处理" value={1}>待处理</Option>
                </Select>)}
              </Form.Item>

              {appeal?.appeal_state > 1 && (<Form.Item label="回复时间" style={{ marginBottom: 0 }}>
                <span>{dayjs(appeal?.response_time).format('YYYY-MM-DD  HH:mm:ss')}</span>
              </Form.Item>)}
              <Form.Item label="回复内容">
                {getFieldDecorator('desciption', {
                  initialValue: appeal?.desciption,
                  rules: [
                    {
                      required: false,
                      message: '请输入客服回复',
                    },
                  ],
                })(<Input.TextArea disabled={isApplyer || appeal?.appeal_state == 2 || appeal?.appeal_state == 3} rows={4} />)}
              </Form.Item></div>)} */}
          </>)}
        <Form.Item wrapperCol={{ span: 24 }} className={styles.footer} required style={{ marginBottom: 0 }}>
          <Button
            type="primary" style={{ marginLeft: "10px" }}
            onClick={this.handleSubmit}
            disabled={loading}
          >提交</Button>
        </Form.Item>
      </Form>
    );
  }
}

function AppealOrderDialog({
  modal: { name },
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) {
  return (
    <Modal
      title={(<>{ownProps.title}{ownProps.type == 3 && <span style={{ fontSize: '12px', marginLeft: '10px', color: '#FF731B' }}>工单申诉/索赔截止日期为确认结算后第30天</span>}</>)}
      destroyOnClose
      footer={null}
      width={500}
      // style={{ top: '30vh' }}
      visible={isOpen}
      onCancel={hide}
      maskClosable={false}

      mask={false}
      wrapClassName="order-detail-modal-wrap"
      maskStyle={{ position: 'absolute' }}
      getContainer={() => document.getElementById('order-detail-wrap') || window}
    >
      <AppealOrderForm {...ownProps} submit={submit} />
    </Modal>
  );
}

export default sagaModal({
  name: 'ORDER_APPEAL_DIALOG',
})(AppealOrderDialog);
